import { useEffect } from 'react';

export default function useDocumentTitle(title: string) {
  useEffect(() => {
    const cleaned = title.replace(/ : Contently$/i, '');
    document.title = cleaned ? `${cleaned} : Contently` : 'Contently';
  }, [title]);
}
